import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import RedirectsTable from '../Components/RedirectsTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedRedirect, setSelectedRedirect] = useState(undefined);
    const [selectedRedirectValue, setSelectedRedirectValue] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: redirects, loading }, refetch] = useAxios("resources/content/admin/redirects");

    if (loading) return <Spinner className="absolute-center" label="Loading Redirects..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Redirect Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <RedirectsTable
                redirects={redirects && redirects.length > 0 ? redirects.sort((a, b) => b.redirectId - a.redirectId) : []}
                setSelectedRedirect={setSelectedRedirect}
                selectedRedirect={selectedRedirect}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, redirectValue) => {
                    setSelectedRedirect(id);
                    setSelectedRedirectValue(redirectValue || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`resources/content/admin/redirects/delete/${selectedRedirect}/`}
                resourceName={selectedRedirectValue}
                resourceType="redirect"
                confirmationValue={selectedRedirectValue || undefined}
            />
        </>
    );
};

export default DefaultPage;
